import OrganizerShowcase from "../components/OrganizerShowcase";

export default function TournamentsHubPage() {
  return <OrganizerShowcase kind="tournaments" />;
}
